<template>
  <div class="time-box">
    <div>{{currentH}} {{currentW}}</div>
    {{currentD}}
<!--    <span>{{ currentTime }}</span>-->
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    icon: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      currentTime: "",
      timer: null,
      currentH: '',
      currentD: '',
      currentW: '',
    };
  },
  mounted() {
    moment.locale("zh-cn");
    this.timer = setInterval(() => {
      this.currentTime = moment().format("llll");
      this.currentD = this.currentTime.slice(0, this.currentTime.indexOf('日') + 1);
      this.currentW = this.currentTime.slice(this.currentTime.indexOf('日') + 1, this.currentTime.indexOf('期') + 2);
      this.currentH = this.currentTime.slice(this.currentTime.indexOf('期') + 2, this.currentTime.length)
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped >
.time-box {
  text-align: center;
  font-size: 14px;
  color: #909399;
  >div{
    color: #333;
  }
}
</style>
